import * as React from 'react';
/**
 * @ignore - internal component.
 */
const FormControlContext = /*#__PURE__*/React.createContext(undefined);
if (process.env.NODE_ENV !== 'production') {
  FormControlContext.displayName = 'FormControlContext';
}
export default FormControlContext;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@mui/material/FormControl/FormControlContext.js
// module id = 499
// module chunks = 0